export const SIDER_COLLAPSED = 'siderMenu/collapsed';
export const SIDER_EXPANDED = 'siderMenu/expanded';
export const DRAWER_VISIBILITY_CHANGED = 'drawer/visibility/changed';

// Static data
export const STATIC_STATUSES_CHANGED = 'static-data/statuses/changed';
export const SELECTED_CITY_CHANGED = 'static-data/selected-city/changed';
export const STATIC_CITY_AND_REGION_CHANGED = 'static-data/city-and-region/changed';
export const STATIC_TICKET_SUB_STATUSES_CHANGED = 'static-data/ticket-sub-statuses/changed';
export const STATIC_COMPETITION_TYPES_CHANGED = 'static-data/competition-types/changed';
export const STATIC_SPORTS_CHANGED = 'static-data/sports/changed';
export const STATIC_SPORTS_MARKETS_CHANGED = 'static-data/sports-markets/changed';
export const STATIC_CATEGORIES_CHANGED = 'static-data/categories/changed';
export const STATIC_TOURNAMENTS_CHANGED = 'static-data/tournaments/changed';
export const STATIC_TOURNAMENTS_CLEARED = 'static-data/tournaments/cleared';
export const STATIC_EVENTS_CHANGED = 'static-data/events/changed';
export const STATIC_MARKETS_CHANGED = 'static-data/markets/changed';
export const STATIC_SPECIFIERS_CHANGED = 'static-data/specifiers/changed';
export const STATIC_OUTCOMES_CHANGED = 'static-data/outcomes/changed';
export const STATIC_EVENT_SEARCH_RESULTS_CHANGED = 'static-data/event-search-results/changed';
export const STATIC_ACTIVE_EVENTS_CHANGED = 'static-data/active-events/changed';
export const STATIC_ACTIVITIES_CHANGED = 'static-data/activities/changed';
export const STATIC_BALANCE_ACTIVITIES_CHANGED = 'static-data/balance-activities/changed';
export const STATIC_GROUPBY_OPTIONS_CHANGED = 'static-data/group-by-options/changed';
export const STATIC_GROUPBY_OPTIONS_CLEARED = 'static-data/group-by-options/cleared';
export const STATIC_ACTION_TYPES_CHANGED = 'static-data/action-types/changed';
export const STATIC_PAYMENT_METHODS_CHANGED = 'static-data/payment-methods/changed';
export const STATIC_PAYMENT_PROVIDERS_CHANGED = 'static-data/payment-providers/changed';
export const STATIC_SOURCES_CHANGED = 'static-data/sources/changed';
export const STATIC_CONDITION_TYPES_CHANGED = 'static-data/condition-types/changed';
export const STATIC_OPERATION_TYPES_CHANGED = 'static-data/operation-types/changed';
export const STATIC_WITHDRAWAL_RULE_CONDITIONS_CHANGED = 'static-data/withdrawal-rule-conditions/changed';
export const STATIC_USER_STATUS_CHANGED = 'static-data/user-status/changed';
export const STATIC_FREEZE_TYPE_CHANGED = 'static-data/freeze-type/changed';
export const STATIC_WALLET_TYPE_CHANGED = 'static-data/wallet-type/changed';
export const STATIC_PLAYER_MASS_UPDATE_ACTION_TYPES_CHANGED = 'static-data/player-mass-update-action-types/changed';
export const STATIC_CHANNEL_RECEIVED = 'STATIC_CHANNEL_RECEIVED';
export const STATIC_PLAYER_SEGMENT_FILTER_TYPES_CHANGED = 'static-data/player-segment-filter-types/changed';
export const STATIC_ARCHIVE_STATUSES_CHANGED = 'static-data/archive-statuses/changed';
export const STATIC_COMMUNICATION_CATEGORIES_CHANGED = 'static-data/communication-categories/changed';
export const STATIC_COMMUNICATION_CHANNELS_CHANGED = 'static-data/communication-channels/changed';
export const STATIC_COMMUNICATION_DIRECTIONS_CHANGED = 'static-data/communication-directions/changed';
export const STATIC_MESSAGE_STATUSES_CHANGED = 'static-data/message-statuses/changed';
export const STATIC_NOTE_CATEGORIES_CHANGED = 'static-data/note-categories/changed';
export const STATIC_LOG_TYPES_CHANGED = 'static-data/request-methods/changed';
export const STATIC_TICKET_OPERATION_TYPES_CHANGED = 'static-data/ticket-operation-types/changed';
export const STATIC_TICKET_OPERATION_STATUSES_CHANGED = 'static-data/operation-statuses/changed';

// Global
export const UPDATE_PASSWORD_MODAL_VISIBILITY_CHANGED = 'updatePassword/modal/visibility/changed';
export const TICKET_INFO_MODAL_PROPS_CHANGED = 'ticket-info/modal/props/changed';
export const ERROR_MODAL_PROPS_CHANGED = 'error/modal/props/changed';
export const APP_VERSION_CHANGED = 'global/app-version/changed';
export const ACTION_BLOCK_CHANGED = 'global/action-block/changed';
export const ACTION_BLOCK_FETCHING = 'global/action-block/fetching';
export const CONFIRM_MODAL_PROPS_CHANGED = 'global/confirm-modal-props/changed';
export const CURRENT_PAGE_TITLE_CHANGED = 'global/current-page-title/changed';
export const TRANSLATION_MODE_CHANGED = 'global/translation-mode/changed';
export const DOWNLOAD_FILE_LIST_CHANGED = 'global/download-file-list/changed';
export const CANCEL_DOWNLOAD_FILE = 'global/download-file/cancelled';

// columns
export const TABLE_VISIBLE_COLUMNS_CHANGED = 'columns/changed';

export const LOGS_DETAILS_CHANGED = 'logs/details/changed';
export const LOGS_PAGE_CHANGED = 'logs/page/changed';
export const LOGS_HAS_MORE_CHANGED = 'logs/has-more/changed';
export const LOGS_FETCHING_CHANGED = 'logs/fetching/changed';
export const LOGS_CHANGED = 'logs/changed';
export const OPERATION_LOGS_CHANGED = 'operation-logs/changed';
export const LOGS_CLEARED = 'logs/cleared';
export const LOGS_CASHIER_DATA_CHANGED = 'logs/cashier/data/changed';
export const LOGS_TERMINAL_DATA_CHANGED = 'logs/terminal/data/changed';
export const LOGS_CASHIER_TICKETS_CHANGED = 'logs/cashier/tickets/changed';
export const LOGS_TERMINAL_TICKETS_CHANGED = 'logs/terminal/tickets/changed';
export const LOGS_CASHIER_LOGIN_HISTORY_CHANGED = 'logs/cashier/login-history/changed';
export const LOGS_CASHIER_TRANSACTIONS_CHANGED = 'logs/cashier/transactions/changed';
export const LOGS_TERMINAL_TRANSACTIONS_CHANGED = 'logs/terminal/transactions/changed';

// ----------- Users ----------- //
export const USERS_RECEIVED = 'USERS_RECEIVED';
export const USERS_FETCHING = 'USERS_FETCHING';
export const USER_RECEIVED = 'USER_RECEIVED';
export const USER_FETCHING = 'USER_FETCHING';
export const USER_FILTERS_CHANGED = 'user/filters/changed';
export const USER_FILTERS_CLEARED = 'user/filters/cleared';
export const MENUS_RECEIVED = 'MENUS_RECEIVED';
export const ROLES_RECEIVED = 'ROLES_RECEIVED';
export const USER_DRAWER_CHANGED = 'USER_DRAWER_CHANGED';

// ----------- Reports ----------- //
export const SALES_REPORTS_CHANGED = 'reports/sales/changed';
export const SALES_FILTERS_CHANGED = 'reports/sales/filters/changed';
export const SALES_REPORTS_FILTERED = 'reports/sales/filtered';
export const SALES_REPORTS_FETCHING = 'reports/sales/fetching';
export const BETS_MONITOR_REPORTS_DATA_CHANGED = 'reports/bets-monitor/changed';
export const BETS_MONITOR_REPORTS_DATA_CLEARED = 'reports/bets-monitor/cleared';
export const BETS_MONITOR_NEW_REPORTS_CHANGED = 'reports/bets-monitor/new/changed';
export const ONLINE_PLAYERS_REPORT_CHANGED = 'reports/online-players-report/changed';
export const ONLINE_PLAYERS_REPORT_CLEARED = 'reports/online-players-report/cleared';
export const REGISTRATIONS_HISTORY_REPORTS_CHANGED = 'online/reports/registrations-history/changed';
export const REGISTRATIONS_HISTORY_REPORTS_CLEARED = 'online/reports/registrations-history/cleared';
export const TICKET_OPERATIONS_HISTORY_REPORTS_CHANGED = 'reports/ticket-operations-history/changed';
export const TICKET_OPERATIONS_HISTORY_REPORTS_CLEARED = 'reports/ticket-operations-history/cleared';

// Gaming Activity
export const GAMING_ACTIVITY_FIRST_GROUP_DATA_CHANGED = 'gaming-activity/first-group/changed';
export const GAMING_ACTIVITY_FIRST_GROUP_DATA_CLEARED = 'gaming-activity/first-group/cleared';
export const GAMING_ACTIVITY_SECOND_GROUP_DATA_CHANGED = 'gaming-activity/second-group/changed';
export const GAMING_ACTIVITY_SECOND_GROUP_DATA_CLEARED = 'gaming-activity/second-group/cleared';
export const GAMING_ACTIVITY_FIRST_GROUP_EXPANDED_ROWS_CHANGED = 'gaming-activity/first-group/expanded/changed';
export const GAMING_ACTIVITY_FIRST_GROUP_EXPANDED_ROWS_CLEARED = 'gaming-activity/first-group/expanded/cleared';
export const GAMING_ACTIVITY_THIRD_GROUP_DATA_CHANGED = 'gaming-activity/third-group/changed';
export const GAMING_ACTIVITY_THIRD_GROUP_DATA_CLEARED = 'gaming-activity/third-group/cleared';
export const GAMING_ACTIVITY_SECOND_GROUP_EXPANDED_ROWS_CHANGED = 'gaming-activity/second-group/expanded/changed';
export const GAMING_ACTIVITY_SECOND_GROUP_EXPANDED_ROWS_CLEARED = 'gaming-activity/second-group/expanded/cleared';

// ----------- general ----------- //
export const UNSAVED_CHANGES = 'UNSAVED_CHANGES';
export const EVENT_TYPES_RECEIVED = 'EVENT_TYPES_RECEIVED';
export const EVENT_STATUSES_RECEIVED = 'EVENT_STATUSES_RECEIVED';
export const MBN_TYPES_RECEIVED = 'MBN_TYPES_RECEIVED';
export const UPDATE_VERSION_RECEIVED = 'UPDATE_VERSION_RECEIVED';
export const APP_VERSIONS_RECEIVED = 'APP_VERSIONS_RECEIVED';
export const APPLICATION_TYPE_CHANGED = 'APPLICATION_TYPE_CHANGED';
// ----------- MBN Templates ----------- //
export const MBN_TOURNAMENTS_RECEIVED = 'MBN_TOURNAMENTS_RECEIVED';
export const MBN_TOURNAMENTS_EDITED = 'MBN_TOURNAMENTS_EDITED';
export const MBN_TOURNAMENTS_RESET = 'MBN_TOURNAMENTS_RESET';
export const MBN_MARKETS_RESET = 'MBN_MARKETS_RESET';
export const MBN_TOURNAMENTS_CLEARED = 'MBN_TOURNAMENTS_CLEARED';
export const MBN_TOURNAMENTS_FETCHING = 'MBN_TOURNAMENTS_FETCHING';
export const MBN_TOURNAMENTS_UPDATE_ORIGINAL = 'MBN_TOURNAMENTS_UPDATE_ORIGINAL';
export const MBN_FILTERS_SAVED = 'MBN_FILTERS_SAVED';
export const MBN_MARKETS_RECEIVED = 'MBN_MARKETS_RECEIVED';
export const MBN_MARKETS_EDITED = 'MBN_MARKETS_EDITED';
export const MBN_MARKETS_FETCHING = 'MBN_MARKETS_FETCHING';
export const MBN_MARKETS_UPDATE_ORIGINAL = 'MBN_MARKETS_UPDATE_ORIGINAL';

// ----------- Market Group Templates ----------- //
export const MARKET_GROUP_LIST_RECEIVED = 'MARKET_GROUP_LIST_RECEIVED';
export const MARKET_GROUP_LIST_FETCHING = 'MARKET_GROUP_LIST_FETCHING';
export const MARKET_GROUP_ITEM_RECEIVED = 'MARKET_GROUP_ITEM_RECEIVED';
export const MARKET_GROUP_ITEM_FETCHING = 'MARKET_GROUP_ITEM_FETCHING';
export const MARKET_GROUP_MARKETS_RECEIVED = 'MARKET_GROUP_MARKETS_RECEIVED';
export const MARKET_GROUP_COLUMN_TYPES_RECEIVED = 'MARKET_GROUP_COLUMN_TYPES_RECEIVED';
export const MARKET_GROUP_OUTCOMES_RECEIVED = 'MARKET_GROUP_OUTCOMES_RECEIVED';

export const MARKET_GROUP_TEMPLATE_LIST_RECEIVED = 'MARKET_GROUP_TEMPLATE_LIST_RECEIVED';
export const MARKET_GROUP_TEMPLATE_LIST_FETCHING = 'MARKET_GROUP_TEMPLATE_LIST_FETCHING';
export const MARKET_GROUP_TEMPLATE_ITEM_RECEIVED = 'MARKET_GROUP_TEMPLATE_ITEM_RECEIVED';
export const MARKET_GROUP_TEMPLATE_ITEM_FETCHING = 'MARKET_GROUP_TEMPLATE_ITEM_FETCHING';
export const MARKET_GROUP_RESULT_TYPE_LIST_RECEIVED = 'MARKET_GROUP_RESULT_TYPE_LIST_RECEIVED';
export const MARKET_GROUP_RESULT_TYPE_LIST_FETCHING = 'MARKET_GROUP_RESULT_TYPE_LIST_FETCHING';
export const MARKET_GROUP_RESULT_TYPE_ITEM_RECEIVED = 'MARKET_GROUP_RESULT_TYPE_ITEM_RECEIVED';
export const MARKET_GROUP_RESULT_TYPE_ITEM_FETCHING = 'MARKET_GROUP_RESULT_TYPE_ITEM_FETCHING';
export const MARKET_GROUP_MARKET_TYPE_LIST_RECEIVED = 'MARKET_GROUP_MARKET_TYPE_LIST_RECEIVED';
export const MARKET_GROUP_MARKET_TYPE_LIST_FETCHING = 'MARKET_GROUP_MARKET_TYPE_LIST_FETCHING';
export const MARKET_GROUP_TEMPLATE_DRAWER_CHANGED = 'MARKET_GROUP_TEMPLATE_DRAWER_CHANGED';
export const MARKET_GROUP_RESULT_TYPE_DRAWER_CHANGED = 'MARKET_GROUP_RESULT_TYPE_DRAWER_CHANGED';
export const MARKET_GROUP_MARKET_TYPE_DRAWER_CHANGED = 'MARKET_GROUP_MARKET_TYPE_DRAWER_CHANGED';
export const MARKET_GROUP_TRANSLATIONS_MODAL_CHANGED = 'MARKET_GROUP_TRANSLATIONS_MODAL_CHANGED';
export const MARKET_GROUP_MULTIPLE_SELECT_TRANSLATIONS_MODAL_CHANGED =
    'MARKET_GROUP_MULTIPLE_SELECT_TRANSLATIONS_MODAL_CHANGED';
export const MARKET_GROUP_SELECT_TRANSLATIONS_MODAL_CHANGED = 'MARKET_GROUP_SELECT_TRANSLATIONS_MODAL_CHANGED';
export const MARKET_GROUP_INPUT_TRANSLATIONS_MODAL_CHANGED = 'MARKET_GROUP_INPUT_TRANSLATIONS_MODAL_CHANGED';
export const MARKET_GROUP_MONITORING_SELECTED_GROUP_CHANGED = 'MARKET_GROUP_MONITORING_SELECTED_GROUP_CHANGED';
export const MARKET_GROUP_NAME_FILTER_CHANGED = 'MARKET_GROUP_NAME_FILTER_CHANGED';

export const MARKET_LABEL_STATIC_DRAWER_CHANGED = 'MARKET_LABEL_STATIC_DRAWER_CHANGED';
export const MARKET_LABEL_STATIC_LIST_RECEIVED = 'MARKET_LABEL_STATIC_LIST_RECEIVED';
export const MARKET_LABEL_STATIC_LIST_FETCHING = 'MARKET_LABEL_STATIC_LIST_FETCHING';
export const MARKET_LABEL_STATIC_ITEM_RECEIVED = 'MARKET_LABEL_STATIC_ITEM_RECEIVED';
export const MARKET_LABEL_STATIC_ITEM_FETCHING = 'MARKET_LABEL_STATIC_ITEM_FETCHING';

// ----------- Bet Acceptance Time Templates ----------- //
export const BAT_LIST_RECEIVED = 'BAT_LIST_RECEIVED';
export const BAT_LIST_FETCHING = 'BAT_LIST_FETCHING';
export const BAT_ITEM_RECEIVED = 'BAT_ITEM_RECEIVED';
export const BAT_ITEM_FETCHING = 'BAT_ITEM_FETCHING';
export const BAT_FILTERS_CHANGED = 'BAT_FILTERS_CHANGED';

// ----------- Bet Acceptance Time Templates ----------- //
export const COMBINATION_LOCK_LIST_RECEIVED = 'COMBINATION_LOCK_LIST_RECEIVED';
export const COMBINATION_LOCK_ITEM_RECEIVED = 'COMBINATION_LOCK_ITEM_RECEIVED';

// ----------- MONITORING ----------- //
export const MONITORING_SPORTS_RECEIVED = 'MONITORING_SPORTS_RECEIVED';
export const MONITORING_EVENTS_RECEIVED = 'MONITORING_EVENTS_RECEIVED';
export const MONITORING_OUTRIGHT_EVENTS_RECEIVED = 'MONITORING_OUTRIGHT_EVENTS_RECEIVED';
export const MONITORING_EVENT_RECEIVED = 'MONITORING_EVENT_RECEIVED';
export const MONITORING_EVENT_FETCHING = 'MONITORING_EVENT_FETCHING';
export const EVENT_MARKETS_RECEIVED = 'EVENT_MARKETS_RECEIVED';
export const EVENT_MARKETS_UPDATED = 'EVENT_MARKETS_UPDATED';
export const MONITORING_SPORTS_FETCHING = 'MONITORING_SPORTS_FETCHING';
export const MONITORING_EVENTS_FETCHING = 'MONITORING_EVENTS_FETCHING';
export const MONITORING_OUTRIGHT_EVENTS_FETCHING = 'MONITORING_OUTRIGHT_EVENTS_FETCHING';
export const MONITORING_LEAGUE_REMOVED = 'MONITORING_LEAGUE_REMOVED';
export const MONITORING_OUTRIGHT_LEAGUE_REMOVED = 'MONITORING_OUTRIGHT_LEAGUE_REMOVED';
export const MONITORING_EVENTS_UPDATED = 'MONITORING_EVENTS_UPDATED';
export const MONITORING_OUTRIGHT_EVENTS_UPDATED = 'MONITORING_OUTRIGHT_EVENTS_UPDATED';
export const MONITORING_EVENT_HISTORY_RECEIVED = 'MONITORING_EVENT_HISTORY_RECEIVED';
export const MONITORING_EVENT_HISTORY_CHANGED = 'MONITORING_EVENT_HISTORY_CHANGED';
export const MONITORING_RISK_DETAILS_RECEIVED = 'MONITORING_RISK_DETAILS_RECEIVED';
export const MONITORING_RISK_DETAILS_CHANGED = 'MONITORING_RISK_DETAILS_CHANGED';
export const MONITORING_BET_INFORMATION_CHANGED = 'MONITORING_BET_INFORMATION_CHANGED';
export const MONITORING_BET_INFORMATION_RECEIVED = 'MONITORING_BET_INFORMATION_RECEIVED';
export const MONITORING_DATES_CHANGED = 'MONITORING_DATES_CHANGED';
export const MONITORING_FILTERS_CHANGED = 'MONITORING_FILTERS_CHANGED';
export const SETTLEMENT_CHANGED = 'SETTLEMENT_CHANGED';
export const MARKET_FETCHING_CHANGED = 'MARKET_FETCHING_DATA_CHANGED';
export const MARKET_DATA_CHANGED = 'MARKET_DATA_CHANGED';
export const MARKET_DATA_CLEARED = 'MARKET_DATA_CLEARED';
export const SETTLEMENT_FETCHING_CHANGED = 'SETTLEMENT_FETCHING_CHANGED';
export const MARKETS_FILTERS_CHANGED = 'MARKETS_FILTERS_CHANGED';
export const TICKET_DATA_CHANGED = 'TICKET_DATA_CHANGED';
export const MONITORING_SET_SELECTED_SPORTID = 'MONITORING_SET_SELECTED_SPORTID';

// ----------- Socket ----------- //
export const SOCKET_INSTANCE_CHANGED = 'socket/instance/changed';
export const SOCKET_CONTEXT_CHANGED = 'socket/context/changed';
export const SOCKET_CONTEXT_CLEARED = 'socket/context/cleared';

// ----------- Auth ----------- //
export const AUTH_USER_LOGGED_IN = 'auth/user/logged-in';
export const SET_LOGIN_FORM_CHANGED = 'auth/login-form/changed';
export const AUTH_USER_LOGGED_OUT = 'auth/user/logged-out';
export const AUTH_USER_FETCHING = 'auth/user/fetching';
export const AUTH_USER_PERMISSIONS_CHANGED = 'auth/user/permissions/changed';

// ----------- Messages ----------- //
export const MESSAGES_FETCHED = 'messages/list/fetched';
export const MESSAGES_CLEARED = 'messages/list/cleared';
export const MESSAGE_DETAILS_FETCHED = 'message/details/fetched';
export const MESSAGE_DETAILS_CLEARED = 'message/details/cleared';
export const MESSAGE_FILTERS_CHANGED = 'messages/filters/changed';

// ----------- Pagination ----------- //
export const SET_PAGINATION = 'set/pagination';
export const CLEAR_PAGINATION = 'clear/pagination';

// ----------- Transactions ----------- //
export const TRANSACTIONS_DATA_CHANGED = 'transactions-data/changed';
export const TRANSACTIONS_DATA_CLEARED = 'transactions-data/cleared';
export const ACCOUNTING_PERIOD_DATA_CHANGED = 'accounting-period-data/changed';
export const ACCOUNTING_PERIOD_DATA_CLEARED = 'accounting-period-data/cleared';

// ----------- Emails ----------- //
export const EMAIL_ADDRESS_LIST_CHANGED = 'emails/address/list/changed';
export const EMAIL_ADDRESS_LIST_FETCHING = 'emails/address/list/fetching';
export const EMAIL_ADDRESS_CHANGED = 'emails/address/item/changed';
export const EMAIL_ADDRESS_FETCHING = 'emails/address/item/fetching';
export const EMAIL_GROUP_LIST_CHANGED = 'emails/group/list/changed';
export const EMAIL_GROUP_LIST_FETCHING = 'emails/group/list/fetching';
export const EMAIL_GROUP_CHANGED = 'emails/group/item/changed';
export const EMAIL_GROUP_FETCHING = 'emails/group/item/fetching';

// Settlement
export const SETTLEMENT_TICKETS_CHANGED = 'settlement/tickets/changed';
export const SETTLEMENT_TICKETS_CLEARED = 'settlement/tickets/cleared';
export const SETTLEMENT_MARKETS_CHANGED = 'settlement/markets/changed';
export const SETTLEMENT_MARKETS_CLEARED = 'settlement/markets/cleared';
export const SETTLEMENT_MARKETS_FILTERS_CHANGED = 'settlement/markets/filters/changed';
export const SETTLEMENT_REQUEST_MODAL_PROPS_CHANGED = 'settlement/request-modal/props/changed';
export const SETTLEMENT_INFO_DRAWER_PROPS_CHANGED = 'settlement/info-drawer/props/changed';

// Quick Bet Search
export const QUICK_SEARCH_TICKET_CHANGED = 'quick-search/ticket/changed';
export const QUICK_SEARCH_FETCHING_CHANGED = 'quick-search/fetching/changed';

// ----------- WEIGHT ----------- //
export const WEIGHTS_SPORTS_CHANGED = 'weight/sports/changed';
export const WEIGHTS_SPORTS_FETCHING = 'weight/sports/fetching';
export const WEIGHTS_SPORTS_FILTERS_CHANGED = 'weight/sports/filters/changed';
export const WEIGHTS_SPORTS_FILTERS_CLEARED = 'weight/sports/filters/cleared';
export const WEIGHTS_CATEGORIES_CHANGED = 'weight/categories/changed';
export const WEIGHTS_CATEGORIES_FETCHING = 'weight/categories/fetching';
export const WEIGHTS_CATEGORIES_FILTERS_CHANGED = 'weight/categories/filters/changed';
export const WEIGHTS_CATEGORIES_FILTERS_CLEARED = 'weight/categories/filters/cleared';
export const WEIGHTS_LEAGUES_CHANGED = 'weight/leagues/changed';
export const WEIGHTS_LEAGUES_FETCHING = 'weight/leagues/fetching';
export const WEIGHTS_LEAGUES_FILTERS_CHANGED = 'weight/leagues/filters/changed';
export const WEIGHTS_LEAGUES_FILTERS_CLEARED = 'weight/leagues/filters/cleared';
export const WEIGHTS_TEAMS_CHANGED = 'weight/teams/changed';
export const WEIGHTS_TEAMS_FETCHING = 'weight/teams/fetching';
export const WEIGHTS_TEAMS_FILTERS_CHANGED = 'weight/teams/filters/changed';
export const WEIGHTS_TEAMS_FILTERS_CLEARED = 'weight/teams/filters/cleared';

//Server Errors
export const SERVER_ERRORS_FETCHING_CHANGED = 'server-errors/fetching/changed';
export const SERVER_ERRORS_CHANGED = 'server-errors/changed';
export const SERVER_ERRORS_TRANSLATIONS_MODAL_PROPS_CHANGED = 'server-errors/translations-modal/props/changed';
export const SERVER_ERRORS_FILTERS_CHANGED = 'server-errors/filters/changed';

//Player Search
export const PLAYER_SEARCH_VISIBLE_FILTERS_LIST_CHANGED = 'player-search/visible-filters-list/changed';
export const PLAYER_SEARCH_FILTERS_LIST_CHANGED = 'player-search/filters-list/changed';
export const PLAYER_SEARCH_VISIBLE_FILTERS_DELETED = 'player-search/visible-filters/deleted';
export const PLAYER_SEARCH_SAVED_FILTERS_DRAWER_VISIBILITY = 'player-search/saved-filters/drawer';
export const PLAYER_SEARCH_LIST_RECEIVED = 'player-search/list/received';
export const PLAYER_SEARCH_ALL_DATA_CLEARED = 'player-search/all/data/cleared';

//Player Details
export const PLAYER_DETAILS_CHANGED = 'player/details/changed';
export const PLAYER_DETAILS_CLEARED = 'player/details/cleared';
export const PLAYER_PROFITS_AND_LOSSES_CHANGED = 'player/profits-losses/changed';
export const PLAYER_PROFITS_AND_LOSSES_CLEARED = 'player/profits-losses/cleared';
export const PLAYER_FINANCIAL_TRANSACTIONS_SUMMARY_CHANGED = 'player/financial-transactions/summary/changed';
export const PLAYER_FINANCIAL_TRANSACTIONS_SUMMARY_CLEARED = 'player/financial-transactions/summary/cleared';
export const PLAYER_FINANCIAL_TRANSACTIONS_DETAILED_CHANGED = 'player/financial-transactions/detailed/changed';
export const PLAYER_FINANCIAL_TRANSACTIONS_DETAILED_CLEARED = 'player/financial-transactions/detailed/cleared';
export const PLAYER_FINANCIAL_TRANSACTIONS_PENDING_WITHDRAWALS_CHANGED =
    'player/financial-transactions/pending-withdrawals/changed';
export const PLAYER_FINANCIAL_TRANSACTIONS_PENDING_WITHDRAWALS_CLEARED =
    'player/financial-transactions/pending-withdrawals/cleared';
export const PLAYER_FINANCIAL_TRANSACTIONS_KPI_CHANGED = 'player/financial-transactions/kpi/changed';
export const PLAYER_FINANCIAL_TRANSACTIONS_KPI_CLEARED = 'player/financial-transactions/kpi/cleared';
export const PLAYER_VERIFICATION_STATUSES_CHANGED = 'player/verification-statuses/changed';
export const PLAYER_COMMUNICATION_PREFERENCES_CHANGED = 'player/communication-preferences/changed';
export const PLAYER_AUTOMATIC_SEGMENT_RETURNED = 'player/automatic-segment/returned';
export const PLAYER_PAYMENT_ACCOUNTS_CHANGED = 'player/payment-accounts/changed';
export const PLAYER_PAYMENT_ACCOUNTS_CLEARED = 'player/payment-accounts/cleared';
export const PLAYER_DOCUMENTS_CHANGED = 'player/documents/changed';
export const PLAYER_DOCUMENTS_CLEARED = 'player/documents/cleared';
export const PLAYER_MESSAGE_THREAD_LIST_CHANGED = 'player/message-thread/list/changed';
export const PLAYER_MESSAGE_THREAD_LIST_CLEARED = 'player/message-thread/list/cleared';
export const PLAYER_MESSAGE_THREAD_SINGLE_CHANGED = 'player/message-thread/single/changed';
export const PLAYER_MESSAGE_THREAD_SINGLE_CLEARED = 'player/message-thread/single/cleared';
export const PLAYER_MESSAGE_MODAL_PROPS_CHANGED = 'player/message/modal/changed';
export const PLAYER_MESSAGE_MODAL_PROPS_CLEARED = 'player/message/modal/cleared';
export const PLAYER_NOTE_LIST_CHANGED = 'player/note/list/changed';
export const PLAYER_NOTE_LIST_CLEARED = 'player/note/list/cleared';
export const PLAYER_NOTE_SINGLE_CHANGED = 'player/note/single/changed';
export const PLAYER_NOTE_SINGLE_CLEARED = 'player/note/single/cleared';
export const PLAYER_NOTE_MODAL_PROPS_CHANGED = 'player/note/modal/changed';
export const PLAYER_NOTE_MODAL_PROPS_CLEARED = 'player/note/modal/cleared';
export const PLAYER_PASSWORD_MODAL_PROPS_CHANGED = 'player/password/modal/changed';
export const PLAYER_PASSWORD_MODAL_PROPS_CLEARED = 'player/password/modal/cleared';
export const PLAYER_INFORMATION_MODAL_PROPS_CHANGED = 'player/information/modal/changed';
export const PLAYER_INFORMATION_MODAL_PROPS_CLEARED = 'player/information/modal/cleared';
export const PLAYER_MANUAL_PAYMENT_MODAL_PROPS_CHANGED = 'player/manual-payment/modal/changed';
export const PLAYER_MANUAL_PAYMENT_MODAL_PROPS_CLEARED = 'player/manual-payment/modal/cleared';
export const PLAYER_DEPOSIT_LIMITS_CHANGED = 'player/responsible-gaming/deposit-limits/changed';
export const PLAYER_GIVE_BONUS_MODAL_PROPS_CHANGED = 'player/give-bonus/modal/changed';
export const PLAYER_GIVE_BONUS_MODAL_PROPS_CLEARED = 'player/give-bonus/modal/cleared';
export const PLAYER_SELF_EXCLUSION_CHANGED = 'player/responsible-gaming/self-exclusion/changed';
export const PLAYER_MANUAL_SEGMENT_MODAL_PROPS_CHANGED = 'player/manual-segment/modal/changed';
export const PLAYER_MANUAL_SEGMENT_MODAL_PROPS_CLEARED = 'player/manual-segment/modal/cleared';

//Permissions Groups
export const PERMISSIONS_GROUPS_DRAWER_CHANGED = 'permissions-groups/drawer/changed';
export const PERMISSIONS_GROUP_RECEIVED = 'permissions-groups/received';

// ----------- User Interface ----------- //
export const TRANSLATIONS_DATA_CHANGED = 'translations/data/changed';
export const TRANSLATIONS_DRAWER_PROPS_CHANGED = 'translations/drawer/props/changed';
export const TRANSLATIONS_FILTERS_CHANGED = 'translations/filters/changed';
export const TRANSLATIONS_FILTERS_CLEARED = 'translations/filters/cleared';
export const TRANSLATIONS_SELECTED_APP_CHANGED = 'translations/selected-app/changed';

// ----------- Accounting Report ----------- //
export const ACCOUNTING_REPORT_RECEIVED = 'ACCOUNTING_REPORT_RECEIVED';

// ----------- Logins History ----------- //
export const LOGINS_HISTORY_LIST_RECEIVED = 'LOGINS_HISTORY_LIST_RECEIVED';
export const CLIENT_TYPES_CHANGED = 'CLIENT_TYPE_CHANGED';

// ----------- Banners ----------- //
export const BANNERS_ORDER_DRAWER_CHANGED = 'banners-order/drawer/changed';
export const BANNERS_PROMOTION_SEARCH_MODAL_CHANGED = 'banners/promotion-search/modal/changed';

// ----------- Bet Banner ----------- //
export const BET_BANNER_LIST_RECEIVED = 'bet-banner/list/received';
export const BET_BANNER_ITEM_CHANGED = 'bet-banner/item/changed';

// ----------- Promotion Banner ----------- //
export const PROMOTION_BANNER_LIST_RECEIVED = 'promotion-banner/list/received';
export const PROMOTION_BANNER_ITEM_CHANGED = 'promotion-banner/item/changed';

// ----------- Coupon Banner ----------- //
export const COUPON_BANNER_LIST_RECEIVED = 'coupon-banner/list/received';
export const COUPON_BANNER_ITEM_CHANGED = 'coupon-banner/item/changed';
export const COUPON_BANNER_PREVIEW_MODAL_PROPS_CHANGED = 'coupon-banner/preview/modal/props/changed';

// ----------- Coupon Banner ----------- //

export const FEATURED_LINKS_LIST_RECEIVED = 'featured-links/received';
export const FEATURED_LINK_CHANGED = 'featured-links/changed';

// ----------- Featured ----------- //

export const FEATURED_EVENTS_CHANGED = 'featured-events/changed';
export const FEATURED_EVENTS_CLEARED = 'featured-events/cleared';

// ----------- Player Activity Report ---------- //

export const PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_DATA_CHANGED = 'player-activity-report/main-group/changed';
export const PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_DATA_CLEARED = 'player-activity-report/main-group/cleared';
export const PLAYER_ACTIVITY_REPORTS_SECONDARY_GROUP_DATA_CHANGED = 'player-activity-report/secondary-group/changed';
export const PLAYER_ACTIVITY_REPORTS_SECONDARY_GROUP_DATA_CLEARED = 'player-activity-report/secondary-group/cleared';
export const PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_EXPANDED_ROWS_CHANGED =
    'player-activity-report/main-group/expanded/changed';
export const PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_EXPANDED_ROWS_CLEARED =
    'player-activity-report/main-group/expanded/cleared';

// ----------- Deposits Withdrawals ----------- //
export const DEPOSITS_WITHDRAWALS_REPORTS_CLEARED = 'deposits-withdrawals/reports/cleared';
export const DEPOSITS_WITHDRAWALS_REPORTS_CHANGED = 'deposits-withdrawals/reports/changed';

//Permissions Groups
export const WITHDRAWAL_AUTOPROCESSING_LIST_CHANGED = 'withdrawal-autoprocessing/list/changed';
export const WITHDRAWAL_AUTOPROCESSING_CURRENT_CHANGED = 'withdrawal-autoprocessing/current/changed';
export const WITHDRAWAL_AUTOPROCESSING_DRAWER_CHANGED = 'withdrawal-autoprocessing/drawer/changed';

// ----------- Tax Report ----------- //J
export const TAX_REPORT_MONTH_DATA_CHANGED = 'TAX_REPORT_MONTH_DATA_CHANGED';
export const TAX_REPORT_DAY_DATA_CHANGED = 'TAX_REPORT_DAY_DATA_CHANGED';
export const TAX_REPORT_ALL_DATA_CLEARED = 'TAX_REPORT_ALL_DATA_CLEARED';

// ----------- Online Reports ----------- //

export const DECLINED_BETS_HISTORY_DATA_CHANGED = 'online-reports/declined-bets-history/changed';
export const DECLINED_BETS_HISTORY_DATA_CLEARED = 'online-reports/declined-bets-history/cleared';

// ----------- Net Cash Report ----------- //
export const NET_CASH_REPORT_FIRST_GROUP_DATA_CHANGED = 'net-cash-report/first-group/changed';
export const NET_CASH_REPORT_FIRST_GROUP_EXPANDED_ROWS_CHANGED = 'net-cash-report/first-group/expanded/changed';
export const NET_CASH_REPORT_FIRST_GROUP_EXPANDED_ROWS_CLEARED = 'net-cash-report/first-group/expanded/cleared';
export const NET_CASH_REPORT_SECOND_GROUP_DATA_CHANGED = 'net-cash-report/second-group/changed';
export const NET_CASH_REPORT_FIRST_GROUP_DATA_CLEARED = 'net-cash-report/first-group/cleared';
export const NET_CASH_REPORT_SECOND_GROUP_DATA_CLEARED = 'net-cash-report/second-group/cleared';
export const NET_CASH_REPORT_LOG_DATA_CHANGED = 'net-cash-report/log/changed';

// ----------- Frozen Accounts Report ----------- //
export const FROZEN_ACCOUNTS_REPORT_DATA_CHANGED = 'frozen-accounts-report/changed';
export const FROZEN_ACCOUNTS_REPORT_DATA_CLEARED = 'frozen-accounts-report/cleared';

// ----------- Sports Performance Report ----------- //
export const SPORT_PERFORMANCE_DATA_CHANGED = 'sport-performance/data/changed';
export const SPORT_PERFORMANCE_LOADING_CHANGED = 'sport-performance/loading/changed';
export const SPORT_PERFORMANCE_DATA_CLEARED = 'sport-performance/data/cleared';

// ----------- Money Transactions ----------- //
export const MONEY_TRANSACTIONS_DATA_CHANGED = 'money-transactions/changed';
export const MONEY_TRANSACTIONS_DETAILS_CHANGED = 'money-transactions/details/changed';
export const MONEY_TRANSACTIONS_ALL_DATA_CLEARED = 'money-transactions/all-data/cleared';

// ----------- Bonus Creation ----------- //
export const BONUS_DATA_CHANGED = 'bonus/data/changed';
export const NEXT_BONUS_STEP = 'bonus/next-step';
export const PREVIOUS_BONUS_STEP = 'bonus/previous-step';
export const RESET_BONUS_STEP = 'bonus/reset-step';
export const RESET_BONUS_DATA_AND_STEP = 'bonus/reset-bonus-data-and-step';
export const BONUSES_DATA_CHANGED = 'bonuses/data/changed';
export const CURRENT_BONUS_CHANGED = 'bonus/current/changed';
export const BONUSES_DATA_CLEARED = 'bonuses/data/cleared';
export const GRAND_MASS_BONUSES_CHANGED = 'bonuses/grand-mass-bonuses/changed';
export const BONUS_ENGINE_MONITOR_DATA_CHANGED = 'bonus/engine/monitor/data/changed';
export const BONUS_ENGINE_MONITOR_DATA_CLEARED = 'bonus/engine/monitor/data/cleared';
export const BONUS_WAGERING_REPORT_DATA_CHANGED = 'bonus/wagering/report/data/changed';
export const BONUS_WAGERING_REPORT_DATA_CLEARED = 'bonus/wagering/report/data/cleared';
export const PLAYER_BONUSES_REPORT_DATA_CHANGED = 'bonus/player-bonuses/report/data/changed';
export const PLAYER_BONUSES_REPORT_ALL_DATA_CLEARED = 'bonus/player-bonuses/report/all/data/cleared';
export const PLAYER_BONUS_REPORT_DATA_CHANGED = 'player-bonus-report/data/changed';
export const BONUS_OFFERS_REPORT_DATA_CHANGED = 'bonus/offers/report/data/changed';
export const BONUS_OFFERS_REPORT_DATA_CLEARED = 'bonus/offers/report/data/cleared';
export const BONUS_REGULAR_REPORT_DATA_CHANGED = 'bonus/regular/report/data/changed';
export const BONUS_REGULAR_REPORT_DATA_CLEARED = 'bonus/regular/report/data/cleared';
export const PLAYER_BONUSES_REPORT_MODAL_CHANGED = 'bonus/player-bonuses/report/modal/changed';
export const GRAND_MASS_BONUSES_TABLE_DATA_CHANGED = 'bonuses/grand-mass-bonuses/table/data/changed';
export const GRAND_MASS_BONUS_CHANGED = 'bonuses/grand-mass-bonus/changed';

// ----------- Player Segmentation ----------- //
export const PLAYER_SEGMENT_LIST_CHANGED = 'player/player-segment/list/changed';
export const PLAYER_SEGMENT_LIST_CLEARED = 'player/player-segment/list/cleared';
export const PLAYER_SEGMENT_CURRENT_CHANGED = 'player/player-segment/current/changed';
export const PLAYER_SEGMENT_CURRENT_CLEARED = 'player/player-segment/current/cleared';
export const PLAYER_SEGMENT_NAME_FILTER_CHANGED = 'player/player-segment/name-filter/changed';
export const PLAYER_SEGMENT_REPORT_CHANGED = 'player/player-segment/report/changed';
export const PLAYER_SEGMENT_REPORT_CLEARED = 'player/player-segment/report/cleared';

// ----------- Inactive Players Report ----------- //
export const INACTIVE_PLAYERS_REPORT_DATA_CHANGED = 'inactive-players/data/changed';
export const INACTIVE_PLAYERS_REPORT_DATA_CLEARED = 'inactive-players/data/cleared';

// ----------- Promotion ----------- //
export const PROMOTION_ISSUING_TYPE_CHANGED = 'promotion/issuing/type/changed';
export const PROMOTION_TRIGGER_TYPE_CHANGED = 'promotion/trigger/type/changed';
export const PROMOTION_MODAL_CHANGED = 'promotion/modal/changed';
export const PROMOTION_FILE_ID_CHANGED = 'promotion/file-id/changed';
export const PROMOTION_FILE_ID_CLEARED = 'promotion/file-id/cleared';
export const PROMOTIONS_DATA_CHANGED = 'promotions/data/changed';
export const PROMOTIONS_NAME_EXISTENCE_CHANGED = 'promotions/name-existence/changed';
export const CURRENT_PROMOTION_CHANGED = 'promotions/current/changed';
export const PROMOTIONS_DATA_CLEARED = 'promotions/data/cleared';
export const PROMOTION_BONUS_OFFERS_DATA_CHANGED = 'promotion/bonus-offers/changed';

// ----------- Saved Filters ----------- //
export const SAVED_FILTERS_CHANGED = 'saved/filters/changed';
export const SAVED_FILTERS_DRAWER_VISIBILITY = 'saved/filters/drawer/visibility';

// ----------- Audit Trail Report ----------- //
export const AUDIT_TRAIL_REPORT_DATA_CHANGED = 'audit-trail/data/changed';
export const AUDIT_TRAIL_REPORT_DATA_CLEARED = 'audit-trail/data/cleared';

// ----------- Notifications ----------- //
export const NOTIFICATIONS_RECEIVED = 'notifications/received';
export const NOTIFICATIONS_RESET = 'notifications/reset';
export const NOTIFICATIONS_REMOVE = 'notifications/remove';

// ----------- Payment Methods ----------- //
export const PAYMENT_METHODS_LIST_CHANGED = 'payment-methods/list/changed';
export const PAYMENT_METHODS_DRAWER_PROPS_CHANGED = 'payment-methods/drawer/changed';

// ----------- Betting Rules ----------- //
export const BETTING_RULES_LIST_CHANGED = 'betting-rules/list/changed';
export const BETTING_RULES_DRAWER_PROPS_CHANGED = 'betting-rules/drawer/changed';

// ----------- Market Descriptions ----------- //
export const MARKET_DESCRIPTIONS_LIST_CHANGED = 'market-descriptions/list/changed';

// ----------- Cashout Block ----------- //
export const CASHOUT_BLOCK_LIST_RECEIVED = 'CASHOUT_BLOCK_LIST_RECEIVED';
export const  CASHOUT_BLOCK_MARKET_TEMPLATE='CASHOUT_BLOCK_MARKET_TEMPLATE';
export const  CASHOUT_BLOCK_MARKETS_CHANGED = 'CASHOUT_BLOCK_MARKETS_CHANGED';
export const CASHOUT_BLOCK_TOURNAMENTS_CHANGED = 'CASHOUT_TOURNAMENTS_CHANGED';
